document.addEventListener("DOMContentLoaded", function () {
  /* ---------- Sticky nav background on scroll ---------- */
  var nav = document.querySelector("[data-cl-nav]");
  if (nav) {
    var onScroll = function () {
      if (window.scrollY > 12) {
        nav.classList.add("is-scrolled");
      } else {
        nav.classList.remove("is-scrolled");
      }
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ---------- FAQ accordion ---------- */
  var faqItems = document.querySelectorAll("[data-cl-faq-item]");
  faqItems.forEach(function (item) {
    var question = item.querySelector("[data-cl-faq-question]");
    var answer = item.querySelector("[data-cl-faq-answer]");
    if (!question || !answer) return;
    question.addEventListener("click", function () {
      var isOpen = item.getAttribute("data-open") === "true";
      faqItems.forEach(function (other) {
        other.setAttribute("data-open", "false");
        var otherAnswer = other.querySelector("[data-cl-faq-answer]");
        if (otherAnswer) otherAnswer.style.maxHeight = null;
      });
      if (!isOpen) {
        item.setAttribute("data-open", "true");
        answer.style.maxHeight = answer.scrollHeight + "px";
      }
    });
  });

  /* ---------- Footer newsletter form (no real backend: local confirmation) ---------- */
  var form = document.querySelector("[data-cl-newsletter-form]");
  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var confirmEl = document.querySelector("[data-cl-newsletter-confirm]");
      form.style.display = "none";
      if (confirmEl) confirmEl.style.display = "block";
    });
  }

  /* ---------- Scroll reveal (transform-only, screenshot-safe) ---------- */
  var revealEls = document.querySelectorAll("[data-cl-reveal]");
  if ("IntersectionObserver" in window && revealEls.length) {
    var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduceMotion) {
      revealEls.forEach(function (el) {
        el.style.transform = "none";
      });
    } else {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.style.transform = "translateY(0) scale(1)";
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15, rootMargin: "0px 0px -10% 0px" },
      );
      revealEls.forEach(function (el) {
        var delay = el.getAttribute("data-cl-reveal-delay") || "0";
        el.style.transform = "translateY(28px) scale(0.985)";
        el.style.transition =
          "transform 0.7s cubic-bezier(0.16,1,0.3,1) " + delay + "ms";
        el.style.willChange = "transform";
        observer.observe(el);
      });
    }
  }

  /* ---------- Granule-fall ambient canvas (crystal shards, not round beads) ---------- */
  var canvas = document.getElementById("cl-granule-canvas");
  if (canvas && canvas.getContext) {
    var reduceMotionCanvas = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var ctx = canvas.getContext("2d");
    var width = window.innerWidth;
    var height = window.innerHeight;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var COLORS = ["#f3b8d0", "#c9b6e4", "#f9d9e6", "#e3d8f2"];

    function resize() {
      width = window.innerWidth;
      height = window.innerHeight;
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = width * dpr;
      canvas.height = height * dpr;
      canvas.style.width = width + "px";
      canvas.style.height = height + "px";
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    resize();
    window.addEventListener("resize", resize);

    var MARGIN = Math.min(220, width * 0.16);
    var count = reduceMotionCanvas ? 0 : 46;
    var grains = [];
    for (var i = 0; i < count; i++) {
      var edge = i % 2 === 0 ? "left" : "right";
      var marginW = Math.max(MARGIN, 120);
      var x = edge === "left" ? Math.random() * marginW : width - Math.random() * marginW;
      grains.push({
        x: x,
        y: Math.random() * height,
        r: 3 + Math.random() * 6,
        speed: 0.25 + Math.random() * 0.6,
        color: COLORS[Math.floor(Math.random() * COLORS.length)],
        edge: edge,
        drift: 6 + Math.random() * 10,
        driftPhase: Math.random() * Math.PI * 2,
        rotation: Math.random() * Math.PI * 2,
        rotSpeed: (Math.random() - 0.5) * 0.04,
        sides: 4 + Math.floor(Math.random() * 3),
      });
    }

    var lastScrollY = window.scrollY;
    var scrollBoost = 0;
    window.addEventListener(
      "scroll",
      function () {
        var y = window.scrollY;
        var delta = Math.abs(y - lastScrollY);
        scrollBoost = Math.min(scrollBoost + delta * 0.02, 6);
        lastScrollY = y;
      },
      { passive: true },
    );

    var t = 0;
    function tick() {
      ctx.clearRect(0, 0, width, height);
      t += 1;
      scrollBoost *= 0.95;
      for (var gi = 0; gi < grains.length; gi++) {
        var g = grains[gi];
        g.y += g.speed + scrollBoost * 0.5;
        g.rotation += g.rotSpeed;
        if (g.y > height + 20) {
          g.y = -20;
          var mw = Math.max(MARGIN, 120);
          g.x = g.edge === "left" ? Math.random() * mw : width - Math.random() * mw;
        }
        var drift = Math.sin(t * 0.01 + g.driftPhase) * g.drift;
        var heightRatio = g.y / height;
        var alpha = Math.max(0.12, 0.62 - heightRatio * 0.4);
        var cx = g.x + drift;
        var cy = g.y;

        ctx.save();
        ctx.translate(cx, cy);
        ctx.rotate(g.rotation);
        ctx.beginPath();
        ctx.globalAlpha = alpha;
        ctx.fillStyle = g.color;
        for (var s = 0; s < g.sides; s++) {
          var angle = (s / g.sides) * Math.PI * 2;
          var jitter = 0.6 + Math.sin(s * 2.4 + g.driftPhase) * 0.35;
          var px = Math.cos(angle) * g.r * jitter;
          var py = Math.sin(angle) * g.r * jitter;
          if (s === 0) ctx.moveTo(px, py);
          else ctx.lineTo(px, py);
        }
        ctx.closePath();
        ctx.fill();
        ctx.restore();
      }
      ctx.globalAlpha = 1;
      if (!reduceMotionCanvas) requestAnimationFrame(tick);
    }
    if (!reduceMotionCanvas) requestAnimationFrame(tick);
  }

  /* ---------- Footer CTA granule burst on hover ---------- */
  var footerCta = document.querySelector("[data-cl-footer-cta]");
  if (footerCta) {
    var burstDots = footerCta.querySelectorAll("[data-cl-burst-dot]");
    footerCta.addEventListener("mouseenter", function () {
      burstDots.forEach(function (dot, i) {
        var angle = (i / burstDots.length) * Math.PI * 2;
        dot.style.transform =
          "translate(" + Math.cos(angle) * 46 + "px, " + Math.sin(angle) * 30 + "px) scale(1)";
        dot.style.opacity = "0.9";
      });
    });
    footerCta.addEventListener("mouseleave", function () {
      burstDots.forEach(function (dot) {
        dot.style.transform = "translate(0,0) scale(0)";
        dot.style.opacity = "0";
      });
    });
  }

  /* ---------- Hero CTA magnetic pull ---------- */
  var heroCta = document.querySelector("[data-cl-hero-cta]");
  if (heroCta) {
    heroCta.addEventListener("mousemove", function (e) {
      var rect = heroCta.getBoundingClientRect();
      var relX = e.clientX - rect.left - rect.width / 2;
      var relY = e.clientY - rect.top - rect.height / 2;
      heroCta.style.transform = "translate(" + relX * 0.18 + "px, " + relY * 0.35 + "px)";
    });
    heroCta.addEventListener("mouseleave", function () {
      heroCta.style.transform = "translate(0,0)";
    });
  }
});

